export default __webpack_public_path__ + "static/media/Mercenary's Straps of Pierced Flesh.d92445ef.jpg";